const removeExtraLineBreaks = string => string.replace(/\n{2,10}/g, '\n');

export default removeExtraLineBreaks;
